// textScroll.js - Fixed version
document.addEventListener('DOMContentLoaded', function() {
    
    // Try multiple possible selectors (most specific to least specific)
    const textContainer = document.querySelector('#textContainer') || 
                         document.querySelector('.text-scroll-container') ||
                         document.querySelector('[data-text-scroll]') ||
                         document.querySelector('.scrolling-text');
    
    // Silently exit if no scrolling text element found
    if (!textContainer) {
        return;
    }
    
    // Ensure GSAP is available
    if (typeof gsap === 'undefined') {
        console.warn('textScroll.js: GSAP library not found');
        return;
    }
    
    // Get the total width of the text container
    const containerWidth = textContainer.scrollWidth;
    
    // Additional check to ensure we have actual content
    if (containerWidth === 0) {
        return;
    }
    
    // Calculate how far we need to move to complete one cycle
    // We'll move by half the container width to create seamless loop
    const moveDistance = containerWidth / 2;
    
    // Create the continuous animation
    gsap.set(textContainer, { x: 0 });
    
    // Create the infinite loop animation
    const tl = gsap.timeline({ repeat: -1 });
    
    tl.to(textContainer, {
        x: -moveDistance,
        duration: 30, // Adjust speed here (lower = faster)
        ease: "none"
    });
    
    // Add pause on hover functionality
    textContainer.addEventListener('mouseenter', () => {
        tl.pause();
    });
    
    textContainer.addEventListener('mouseleave', () => {
        tl.resume();
    });
    
    // Optional: Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
            // Recalculate on resize if needed
            const newContainerWidth = textContainer.scrollWidth;
            const newMoveDistance = newContainerWidth / 2;
            
            // Update the animation
            tl.kill();
            gsap.set(textContainer, { x: 0 });
            
            const newTl = gsap.timeline({ repeat: -1 });
            newTl.to(textContainer, {
                x: -newMoveDistance,
                duration: 40,
                ease: "none"
            });
            
            // Reassign timeline reference
            // tl = newTl;
        }, 250);
    });
});